import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ResultBase } from "@intranet/core/types";
import { AddScheduleRequest, GetSchedulesResult, ScheduleJobDetail } from "./schedule.types";

@Injectable({
    providedIn: 'root',
})export class ScheduleService {
    constructor(
        private _http: HttpClient,
        @Inject('BASE_URL') private originUrl: string
    ) {}

    getSchedule() : Observable<GetSchedulesResult> {
        return this._http.get<GetSchedulesResult>(this.originUrl + 'api/schedule/getschedules');
    }

    getJobNames(): Observable<ScheduleJobDetail[]> {
        return this._http.get<ScheduleJobDetail[]>(this.originUrl + 'api/schedule/getjobnames');
    }

    addSchedule(request: AddScheduleRequest): Observable<ResultBase> {
        return this._http.post<ResultBase>(this.originUrl + 'api/schedule/add', request);
    }

    deleteSchedule(jobScheduleId: number): Observable<ResultBase> {
        return this._http.post<ResultBase>(this.originUrl + 'api/schedule/deleteschedule/' + jobScheduleId, {});
    }
}
